import { NewPaymentContext } from 'components/payment/payment.context';
import { useContext, useEffect } from 'react';
import SpreedlyCard303942 from './spreedly-card-303942.component';
import { useCheckoutPaymentLoading } from 'pages/checkout/checkout.component';
import SpreedlyContext from '../spreedly.context';

const SpreedlyCard303942Container = props => {
  const { refetchInitOrder } = useContext(NewPaymentContext);
  const { tokenizationSuccess } = useContext(SpreedlyContext);
  const addPromise = useCheckoutPaymentLoading(state => state.addPromise);

  useEffect(() => {
    if (tokenizationSuccess) addPromise(refetchInitOrder());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <SpreedlyCard303942 {...props} />;
};

export default SpreedlyCard303942Container;
